<span class="perc-crescimento-icon"
    [class.negativo]="percCrescimento < 0"
    [class.manteve]="percCrescimento == 0"
    [class.positivo]="percCrescimento > 0"
    title="{{title}}">

    <i class="fas fa-arrow-down" *ngIf="percCrescimento < 0"></i>
    <i class="fas fa-equals" *ngIf="percCrescimento == 0"></i>
    <i class="fas fa-arrow-up" *ngIf="percCrescimento > 0"></i>
</span>